export interface ChatReasoningStep {
  category?: string;
  result?: string;
  resultLines?: string[];
}

export const NONE_DEVICE_SPECIFIC = 'None Device Specific';
export const NONE_DEVICE_SPECIFIC_TRANSLATION_KEY = 'chatbot.deviceSpecific.none';

export interface ChatMessage {
  accountId: string;
  uuid: string;
  chatId: string;
  number: number;
  from: string;
  text: string;
  serial: string;
  material: string;
  family: string | null;
  version?: string | null;
  timestamp: string;
  type: string;
  widget?: string;
  iStreaming?: boolean;
  options?: string[];
  isOptionAnswer?: boolean;
  instrumentOptionSelected?: boolean;
  final_answer?: boolean;
  suggestions?: string[];
  sessionid?: string;
  message_info?: string;
  botInformation?: string;
  interruptedByUser?: boolean;
  interruptedLabel?: string;
  // Feedback related (Like / Dislike + optional comment)
  feedbackType?: 'like' | 'dislike';
  feedbackLocked?: boolean; // once a choice is made disable buttons
  isMandatory?: boolean; // whether feedback text is mandatory (dislike => true)
  feedbackText?: string; // user written feedback
  feedbackSubmitted?: boolean; // POST completed
  reasoningTrace?: string[];
  reasoningSteps?: ChatReasoningStep[];
  reasoningDurationMs?: number;
  reasoningStartedAt?: number;
  thoughtDurationLabel?: string;
}

export type ChatMessages = ChatMessage[];